/**
 * Declared list of farm segment fields that are stored and replayed as one value, never diffed.
 *
 * Purpose: each value here is the output of one rating, not an edit to the previous segment's value,
 * so a partial delta of it is meaningless. `farmClarionDoorIds` is also stored in two shapes. Offer
 * rating and bind write the `{ liabilityClarionDoorId, risksClarionDoorIds }` map the schema
 * declares; endorsement re-rating (#35036) and renewals write the farm rater's positional, id-less
 * `{ locationId, ids }[]`. Diffing or merging across those shapes either threw
 * (`t.findIndex is not a function`, cfm-production 2026-09-22) or wrote keys of one onto the other.
 *
 * Flow: two sites have to agree. The policy-mod delta writer (`calculateSegmentDelta`) carries the
 * current value whole whenever it changes, and the farm-utils reader (`applyFarmObjectDelta`)
 * assigns it verbatim. Either one alone loses data: a whole read of a sparse delta drops the
 * unchanged entries.
 *
 * Key decision: separate from `array-merge-policy` because that registry is checked against the
 * schema's list fields, and the schema declares `farmClarionDoorIds` as an object.
 *
 * Limit: keyed by bare field name, like the other segment-merge registries.
 */
export const WHOLE_VALUE_FIELD_NAMES: readonly string[] = Object.freeze(['farmClarionDoorIds']);

export function isWholeValueField(fieldName: string): boolean {
  return WHOLE_VALUE_FIELD_NAMES.includes(fieldName);
}
